// Raiz redireciona pra /renato via next.config.js. Este arquivo existe só como fallback.
export default function Root() {
  return null;
}
